(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ee-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTabs(scope) {
      var root = scope.querySelector('[data-ee-faq]') || scope;
      if (!root || root.getAttribute('data-ee-faq-ready') === 'true') return;

      root.querySelectorAll('[data-ee-faq-tab]').forEach(function (button) {
        if (button.getAttribute('data-ee-faq-bound') === 'true') return;
        button.setAttribute('data-ee-faq-bound', 'true');
        button.addEventListener('click', function () {
          var tab = button.closest('.ee-faq__item');
          var inner = tab.querySelector('.ee-faq__inner-panel');
          var isOpen = button.getAttribute('aria-expanded') === 'true';

          root.querySelectorAll('.ee-faq__item').forEach(function (other) {
            var otherButton = other.querySelector('[data-ee-faq-tab]');
            var otherInner = other.querySelector('.ee-faq__inner-panel');
            if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
            if (otherInner) otherInner.style.maxHeight = null;
          });

          if (!isOpen && inner) {
            button.setAttribute('aria-expanded', 'true');
            inner.style.maxHeight = inner.scrollHeight + 'px';
          }
        });
      });

      root.setAttribute('data-ee-faq-ready', 'true');
    }

    function init(scope) {
      var root = scope || document;
      root.querySelectorAll('[data-ee-faq]').forEach(function (sectionRoot) {
        initTabs(sectionRoot);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      var sectionRoot = event.target.querySelector('[data-ee-faq]');
      if (sectionRoot) sectionRoot.removeAttribute('data-ee-faq-ready');
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-featured-product-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function whenFlickityReady(callback) {
      if (typeof Flickity === 'function') {
        callback();
        return;
      }
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (typeof Flickity === 'function') {
          clearInterval(timer);
          callback();
        } else if (tries > 50) {
          clearInterval(timer);
        }
      }, 100);
    }

    function initGallery(root) {
      var main = root.querySelector('[data-fpv2-main]');
      if (!main || root.getAttribute('data-fpv2-ready') === 'true') return;
      if (main.querySelectorAll('.featured-product-v2__slide').length < 2) {
        root.setAttribute('data-fpv2-ready', 'true');
        return;
      }

      var flkty = new Flickity(main, {
        prevNextButtons: false,
        pageDots: false,
        adaptiveHeight: true,
        wrapAround: false,
        dragThreshold: 8,
        cellAlign: 'left',
        contain: true,
        percentPosition: false,
      });

      requestAnimationFrame(function () {
        flkty.resize();
      });

      var thumbs = root.querySelectorAll('[data-fpv2-thumb]');
      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          flkty.select(index);
        });
      });

      flkty.on('select', function () {
        thumbs.forEach(function (thumb, index) {
          thumb.classList.toggle('is-selected', index === flkty.selectedIndex);
        });
      });

      root.setAttribute('data-fpv2-ready', 'true');
    }

    function initTabs(scope) {
      scope.querySelectorAll('[data-fpv2-tab]').forEach(function (button) {
        if (button.getAttribute('data-fpv2-bound') === 'true') return;
        button.setAttribute('data-fpv2-bound', 'true');
        button.addEventListener('click', function () {
          var tab = button.closest('.featured-product-v2__tab');
          var inner = tab.querySelector('.featured-product-v2__tab-inner');
          var isOpen = button.getAttribute('aria-expanded') === 'true';

          scope.querySelectorAll('.featured-product-v2__tab').forEach(function (other) {
            var otherButton = other.querySelector('[data-fpv2-tab]');
            var otherInner = other.querySelector('.featured-product-v2__tab-inner');
            otherButton.setAttribute('aria-expanded', 'false');
            otherInner.style.maxHeight = null;
          });

          if (!isOpen) {
            button.setAttribute('aria-expanded', 'true');
            inner.style.maxHeight = inner.scrollHeight + 'px';
          }
        });
      });
    }

    function initForms(scope) {
      scope.querySelectorAll('[data-fpv2-form]').forEach(function (form) {
        if (form.getAttribute('data-fpv2-bound') === 'true') return;
        form.setAttribute('data-fpv2-bound', 'true');
        form.addEventListener('submit', function (event) {
          var button = form.querySelector('[data-fpv2-atc]');
          if (!button) return;
          event.preventDefault();
          button.setAttribute('disabled', 'disabled');
          document.dispatchEvent(new CustomEvent('theme:loading:start'));

          var payload = {};
          var allowed = { id: true, quantity: true, selling_plan: true };
          new FormData(form).forEach(function (value, key) {
            if (!allowed[key]) return;
            if (key === 'selling_plan' && !value) return;
            if (key === 'id' || key === 'quantity' || key === 'selling_plan') {
              payload[key] = parseInt(value, 10);
            } else {
              payload[key] = value;
            }
          });

          var cartAddUrl = window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add';
          fetch(cartAddUrl + '.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          })
            .then(function (response) {
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
              button.removeAttribute('disabled');
              if (response.ok) {
                form.dispatchEvent(
                  new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                      quantity: parseInt(payload.quantity || '1', 10),
                    },
                  })
                );
              } else {
                return response.json().then(function (content) {
                  var error = document.createElement('span');
                  error.className = 'featured-product-v2__error';
                  error.textContent = content.description || 'Unable to add to cart';
                  button.insertAdjacentElement('afterend', error);
                  setTimeout(function () {
                    error.remove();
                  }, 2500);
                });
              }
            })
            .catch(function () {
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
              button.removeAttribute('disabled');
            });
        });
      });
    }

    function initReviewJump(scope) {
      scope.querySelectorAll('.okeReviews-reviewsCarousel-btn').forEach(function (button) {
        if (button.getAttribute('data-fpv2-reviews-bound') === 'true') return;
        button.setAttribute('data-fpv2-reviews-bound', 'true');
        button.addEventListener('click', function (event) {
          var target = document.querySelector('[data-oke-widget]');
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    function init(scope) {
      var root = scope || document;
      whenFlickityReady(function () {
        root.querySelectorAll('[data-fpv2-gallery]').forEach(initGallery);
      });
      root.querySelectorAll('.featured-product-v2').forEach(function (sectionRoot) {
        initTabs(sectionRoot);
        initForms(sectionRoot);
        initReviewJump(sectionRoot);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
